import { createFileRoute } from '@tanstack/react-router'

import { AdminInvitesPage } from '@/pages/settings/AdminInvitesPage'

export const Route = createFileRoute('/_authenticated/settings/admin-invites')({
  component: AdminInvitesPage,
})
